import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "schoolisation",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "schoolisation-chunk" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
});
